module.exports = __webpack_public_path__ + "img/share.088c9db2.svg";